import React, { useState, useEffect, useRef, useCallback } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useSpeakAnswer } from '../../lib/useSpeakAnswer';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import './VisionPerception.css';

/* eslint-disable react-hooks/exhaustive-deps */

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/vision/';

const EXERCISE_DATA = [
  // --- НАЛОЖЕННЫЕ ИЗОБРАЖЕНИЯ ---
  { id: 1, type: 'overlapping', image: `${S3_BASE_URL}overlapping/1.png`, question: 'Какой фрукт ты видишь на картинке?', validAnswers: ['Груша'] },
  { id: 2, type: 'overlapping', image: `${S3_BASE_URL}overlapping/1.png`, question: 'Какой овощ ты видишь на картинке?', validAnswers: ['Помидор'] },
  { id: 3, type: 'overlapping', image: `${S3_BASE_URL}overlapping/2.png`, question: 'Какую птицу ты видишь на картинке?', validAnswers: ['Утка', 'Уточка'] },
  { id: 4, type: 'overlapping', image: `${S3_BASE_URL}overlapping/3.png`, question: 'Какую игрушку ты видишь на картинке?', validAnswers: ['Юла'] },
  { id: 5, type: 'overlapping', image: `${S3_BASE_URL}overlapping/3.png`, question: 'Какой фрукт ты видишь на картинке?', validAnswers: ['Виноград', 'Банан'] },
  { id: 6, type: 'overlapping', image: `${S3_BASE_URL}overlapping/3.png`, question: 'Какое животное ты видишь на картинке?', validAnswers: ['Собака', 'Собачка', 'Щенок'] },
  { id: 7, type: 'overlapping', image: `${S3_BASE_URL}overlapping/3.png`, question: 'Какое насекомое ты видишь на картинке?', validAnswers: ['Божья коровка'] },
  { id: 8, type: 'overlapping', image: `${S3_BASE_URL}overlapping/4.png`, question: 'Какую игрушку ты видишь на картинке?', validAnswers: ['Пирамидка', 'Мишка', 'Медведь', 'Медвежонок'] },
  { id: 9, type: 'overlapping', image: `${S3_BASE_URL}overlapping/4.png`, question: 'Какой овощ ты видишь на картинке?', validAnswers: ['Морковь', 'Морковка'] },
  { id: 10, type: 'overlapping', image: `${S3_BASE_URL}overlapping/4.png`, question: 'Какое лакомство ты видишь на картинке?', validAnswers: ['Мороженое'] },

  // --- НЕПОЛНЫЕ РИСУНКИ ---
  { id: 11, type: 'incomplete', image: `${S3_BASE_URL}house_half.png`, question: 'Что это?', validAnswers: ['Дом'] },
  { id: 12, type: 'incomplete', image: `${S3_BASE_URL}ball_half.png`, question: 'Что это?', validAnswers: ['Мяч'] },
  { id: 13, type: 'incomplete', image: `${S3_BASE_URL}tree_half.png`, question: 'Что это?', validAnswers: ['Ёлка'] }, 
  { id: 14, type: 'incomplete', image: `${S3_BASE_URL}glasses_half.png`, question: 'Что это?', validAnswers: ['Очки'] },
  { id: 15, type: 'incomplete', image: `${S3_BASE_URL}airplane_half.png`, question: 'Что это?', validAnswers: ['Самолёт'] },
  { id: 16, type: 'incomplete', image: `${S3_BASE_URL}hat_half.png`, question: 'Что это?', validAnswers: ['Шапка'] },
  
  // --- СИЛУЭТЫ ---
  { id: 20, type: 'silhouette', image: `${S3_BASE_URL}snake_silhouette.png`, question: 'Кто это?', validAnswers: ['Змея'] },
  { id: 17, type: 'silhouette', image: `${S3_BASE_URL}hedgehog_silhouette.png`, question: 'Кто это?', validAnswers: ['Ёж', 'Ёжик'] },
  { id: 18, type: 'silhouette', image: `${S3_BASE_URL}lion_silhouette.png`, question: 'Кто это?', validAnswers: ['Лев'] },
  { id: 19, type: 'silhouette', image: `${S3_BASE_URL}bear_silhouette.png`, question: 'Кто это?', validAnswers: ['Медведь', 'Мишка', 'Медвежонок'] },

  // --- ЗАШТРИХОВАННЫЕ КАРТИНКИ ---
  { id: 23, type: 'scratched', image: `${S3_BASE_URL}elephant_scratched.png`, question: 'Кто здесь спрятался?', validAnswers: ['Слон'] },
  { id: 21, type: 'scratched', image: `${S3_BASE_URL}hedgehog_scratched.png`, question: 'Кто здесь спрятался?', validAnswers: ['Ёжик', 'Ёж'] },
  { id: 22, type: 'scratched', image: `${S3_BASE_URL}cat_scratched.png`, question: 'Кто здесь спрятался?', validAnswers: ['Кот', 'Кошка', 'Котёнок'] },
  { id: 24, type: 'scratched', image: `${S3_BASE_URL}duck_scratched.png`, question: 'Кто здесь спрятался?', validAnswers: ['Утка', 'Уточка'] },
];

const RECOGNITION_TIMEOUT_MS = 8000;

const VisionPerception = ({ onBack, onComplete }) => {
  const { start: startSpeakRecognition, stop: stopSpeakRecognition } = useSpeakAnswer('VisionPerception');
  const { play: playInstruction, stop: stopInstruction } = useInstructionAudio();
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [answerLog, setAnswerLog] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [recognizerReady, setRecognizerReady] = useState(false);

  const hasAnsweredRef = useRef(false);

  useEffect(() => {
    const shuffled = [...EXERCISE_DATA].sort(() => Math.random() - 0.5);
    setQuestions(shuffled);
  }, []);

  const currentQuestion = questions[currentIndex];
  const totalQuestions = questions.length;

  const stopAll = () => {
    stopSpeakRecognition();
    stopInstruction();
  };

  const goToNextQuestion = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex < totalQuestions - 1) {
        return prevIndex + 1;
      } else {
        setShowResult(true);
        return prevIndex;
      }
    });
  };

  const finishAnswer = (question, correct, recognizedText) => {
    if (hasAnsweredRef.current) return;
    hasAnsweredRef.current = true;
    stopAll();

    setIsSpeaking(false);
    setIsListening(false);
    setSelectedAnswer(recognizedText);
    setIsCorrect(correct);
    setAnswers((prev) => [...prev, correct]);
    setAnswerLog((prev) => [...prev, {
      category: question.type,
      item: question.validAnswers[0],
      correct,
      recognizedText,
    }]);

    setTimeout(goToNextQuestion, 1200);
  };

  const startListening = (question) => {
    hasAnsweredRef.current = false;
    setRecognizerReady(false);

    // Free-response picture naming: any of the question's validAnswers
    // counts as correct, so they all share the 'correct' key — matchCandidate
    // just needs to recognize one of them.
    startSpeakRecognition(
      question.validAnswers.map((answer) => ({ key: 'correct', text: answer })),
      {
        timeoutMs: RECOGNITION_TIMEOUT_MS,
        onListening: () => setRecognizerReady(true),
        onResult: ({ matchedKey, said }) => {
          finishAnswer(question, matchedKey === 'correct', said || null);
        },
      }
    );
  };

  // Единая функция обработки вопроса (озвучка + запуск прослушки)
  const processQuestion = useCallback(() => {
    if (!currentQuestion || showResult) return;
    stopAll();

    setIsListening(true);
    setIsSpeaking(false);
    setSelectedAnswer(null);
    setIsCorrect(null);

    // Start the recognizer connecting at the same time as the voiceover
    // (model load + mic connect), instead of only starting it afterward —
    // it used to still be warming up by the time the child could speak.
    startListening(currentQuestion);

    playInstruction(currentQuestion.question, () => {
      setIsListening(false);
      setIsSpeaking(true);
    });
  }, [currentQuestion, showResult]);

  useEffect(() => {
    processQuestion();
    return () => stopAll();
  }, [currentIndex, showResult, processQuestion]);

  // Кнопка повтора инструкции
  const repeatInstruction = useCallback(() => {
    if (isCorrect !== null) return; // Если уже ответили, повтор не нужен
    processQuestion();
  }, [processQuestion, isCorrect]);

  // --- ЛОГИКА РЕЗУЛЬТАТА ---
  useEffect(() => {
    if (!showResult) return;

    const timer = setTimeout(() => {
      const correctCount = answers.filter(a => a === true).length;
      const score = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0;

      const categoryTotals = {};
      questions.forEach((q, index) => {
        if (!q || !q.type) return;
        if (!categoryTotals[q.type]) categoryTotals[q.type] = { total: 0, correct: 0 };
        categoryTotals[q.type].total += 1;
        if (answers[index] === true) categoryTotals[q.type].correct += 1;
      });
      const byCategory = {};
      const counts = {};
      Object.entries(categoryTotals).forEach(([cat, { total, correct }]) => {
        byCategory[cat] = Math.round((correct / total) * 100);
        counts[cat] = { total, correct };
      });

      const categoryItems = {};
      answerLog.forEach(({ category, item, correct }) => {
        if (!categoryItems[category]) categoryItems[category] = { correctItems: [], failedItems: [] };
        const bucket = correct ? categoryItems[category].correctItems : categoryItems[category].failedItems;
        if (!bucket.includes(item)) bucket.push(item);
      });

      if (onComplete) {
        onComplete({ 
          testId: 'VisionPerception', 
          score: score, 
          details: { 
            total: totalQuestions, 
            correct: correctCount,
            byCategory,
            counts,
            categoryItems,
          }
        });
      } else {
        onBack();
      }
    }, 4000);

    return () => clearTimeout(timer);
  }, [showResult, answers, answerLog, questions, totalQuestions, onBack, onComplete]);

  // --- ЭКРАН РЕЗУЛЬТАТА ---
  if (showResult) {
    const correctCount = answers.filter(a => a === true).length;
    return (
      <ModuleTemplate 
        progress={answers} 
        totalQuestions={totalQuestions} 
        forceStop={true}
        onComplete={onComplete || onBack}
      >
        <div className="result-content">
          <h2 className="result-title">🎉 Упражнение завершено!</h2>
          <div className="result-score">
            <span className="score-number">{correctCount}</span>
            <span className="result-total"> / {totalQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  // --- ЭКРАН ЗАГРУЗКИ ---
  if (!currentQuestion) {
    return (
      <ModuleTemplate 
        progress={[]} 
        totalQuestions={1} 
        forceStop={true}
        onComplete={onComplete || onBack}
      >
        <div className="loading-text">Загрузка...</div>
      </ModuleTemplate>
    );
  }

  // --- ОСНОВНОЙ ЭКРАН ---
  return (
    <ModuleTemplate 
      progress={answers} 
      totalQuestions={totalQuestions} 
      forceStop={true}
      onComplete={onComplete || onBack}
      onRepeat={repeatInstruction}
      disabled={isCorrect !== null}
    >
      <div className="vision-perception-container">
        <div className="vision-image-wrapper">
          <img 
            src={currentQuestion.image} 
            alt={currentQuestion.question} 
            className="vision-img"
            onError={(e) => { e.target.src = '/placeholder.png'; }}
          />
        </div>

        <div className="vision-indicators">
          <div className={`indicator listen ${isListening ? 'active' : ''}`}>
            <span className="indicator-icon">🎧</span>
          </div>
          <div className={`indicator speak ${isSpeaking && recognizerReady ? 'active' : ''}`}>
            <span className="indicator-icon">🗣️</span>
          </div>
        </div>
      </div>
    </ModuleTemplate>
  );
};

export default VisionPerception;